import { render, staticRenderFns } from "./ClassifyQuestion.vue?vue&type=template&id=347a34ce&scoped=true&"
import script from "./ClassifyQuestion.vue?vue&type=script&lang=js&"
export * from "./ClassifyQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ClassifyQuestion.vue?vue&type=style&index=0&id=347a34ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a34ce",
  null
  
)

export default component.exports